// Las versiones de contrato que trae una liquidación del cierre (Mario, 28-oct): `terms_version` es la vigente hoy, pero las líneas
// pueden venir de otras (MT-LEGACY). Cobranza las trae en `cobranza.por_version`; la cesión de deuda, en cada partida.
// Sin tipos complejos: test/liquidacion-textos-release-28.test.mjs lo carga sin typescript.

export const versionesDe = (l: any) => {
  const out: any[] = [];
  const poner = (c: any) => { if (c && out.indexOf(c) < 0) out.push(c); };
  poner(l && l.terms_version);
  Object.keys((l && l.cobranza && l.cobranza.por_version) || {}).forEach(poner);
  ((l && l.partidas) || []).forEach((p: any) => poner(p && p.terms_version));
  return out;
};

export const textoVersiones = (l: any) => versionesDe(l).join(' · ');

export const incluyeLegacy = (l: any) => versionesDe(l).some((c: any) => /-LEGACY$/.test(String(c)));
